import get from 'lodash/get';
import { Global } from 'state/Global';

export function selectImpersonation(state: Global) {
  return state.app.get('impersonation');
}

export function selectIsImpersonating(state: Global) {
  const impersonation = selectImpersonation(state);
  return get(impersonation, 'activeSession', false);
}
